<template>
    <div class="channel-lineup">
        <div class="open-wrapper pointer" @click="openModal">
            <slot>
                <a href="javascript://void(0)">Open</a>
            </slot>
        </div>

        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               height="auto">
            <div class="dashboard-block">
                <header>
                    <h4>{{feature.title}}</h4><br>
                    <h5>Channel Lineup</h5>

                    <a href="javascript://void" class="back" @click="closeModal">Back</a>
                </header>

                <div class="row">
                    <div class="col-sm-6" v-for="channels in chunkedData">
                        <ul class="list-unstyled">
                            <li v-for="channel in channels" class="margin-sm-bottom">
                                {{channel}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        props: {
            feature: {
                type: Object,
                required: true,
            },

            modalId: {
                default(){
                    return Math.random().toString();
                },
                type: String
            },
        },

        data(){
            return {};
        },

        computed: {
            chunkedData(){
                if( this.feature.data && this.feature.data.length > 1 ){
                    return _.chunk( this.feature.data, _.floor( this.feature.data.length / 2 ) );
                }

                return [];
            }
        },

        methods: {
            closeModal(){
                this.$modal.hide( this.modalId );
            },

            openModal(){
                this.$modal.show( this.modalId );
            },
        }
    }
</script>